import { Decision } from "appworks/state-machine/decisions/decision";
import { stateMachine, SuperStateNode } from "appworks/state-machine/state-machine";
import { State } from "appworks/state-machine/states/state";
import { IsTGRAutoplay } from "decisions/is-tgr-autoplay";
import { IsTGRFirstFreespin } from "decisions/is-tgr-first-freespin";
import { IsTGRFreespinsTriggered } from "decisions/is-tgr-freespins-triggered";
import { IsTGRInstantWin } from "decisions/is-tgr-instant-win";
import { IsTGRWin } from "decisions/is-tgr-win";
import { ShouldTGRExitFreespins } from "decisions/should-tgr-exit-freespins";
import { PartnerConnectHistoryPopupState } from "partner-connect/states/partner-connect-history-complete";
import { PartnerConnectHistorySpin } from "partner-connect/states/partner-connect-history-spin";
import { PartnerConnectHistoryStart } from "partner-connect/states/partner-connect-history-start";
import { PartnerConnectIsHistory } from "partner-connect/states/partner-connect-is-history";
import { PartnerConnectIsHistoryComplete } from "partner-connect/states/partner-connect-is-history-complete";
import { FreespinsRetriggered } from "slotworks/state-machine/standard/decisions/freespins-retriggered";
import { InFreespins } from "slotworks/state-machine/standard/decisions/in-freespins";
import { IsRecovery } from "slotworks/state-machine/standard/decisions/is-recovery";
import { Autoplay } from "slotworks/state-machine/standard/states/autoplay";
import { DelayState } from "slotworks/state-machine/standard/states/delay-state";
import { FreespinIdle } from "slotworks/state-machine/standard/states/freespin-idle";
import { Spin } from "slotworks/state-machine/standard/states/spin";
import { TGRAddQuickhitSymbolsToReels } from "states/freespins/tgr-add-quickhit-symbols-to-reels";
import { TGREnterFreespins } from "states/freespins/tgr-enter-freespins";
import { TGRExitFreespins } from "states/freespins/tgr-exit-freespins";
import { TGRPartnerConnectHistoryFreespin } from "states/freespins/tgr-partner-connect-history-spin";
import { TGRRequestFreespin } from "states/freespins/tgr-request-freespin";
import { TGRRetriggerFreespins } from "states/freespins/tgr-retrigger-freespins";
import { TGRShowInstantWins } from "states/instant-wins/tgr-show-instant-wins";
import { TGRRecoverySpin } from "states/recovery/tgr-recovery-spin";
import { TGREnd } from "states/tgr-end";
import { TGRIdle } from "states/tgr-idle";
import { TGRInit } from "states/tgr-init";
import { TGRRequestSpin } from "states/tgr-request-spin";
import { TGRLoopwins } from "states/winnings/tgr-loop-wins";
import { TGRLoopWinsHistoryState } from "states/winnings/tgr-loop-wins-history-state";
import { TGRShowWinLines } from "states/winnings/tgr-show-win-lines";
import { TGRWinCycle } from "states/winnings/tgr-win-cycle";

export function TGRSetupStates() {

    // states
    const tgrRecoverySpin: State                        = new TGRRecoverySpin();
    const tgrInit: State                                = new TGRInit();
    const tgrIdle: State                                = new TGRIdle();
    const tgrRequestSpin: State                         = new TGRRequestSpin();
    const spin: State                                   = new Spin({ enableSafetyCheck: false });
    const tgrShowInstantWins: State                     = new TGRShowInstantWins();
    const tgrShowWinLines: State                        = new TGRShowWinLines({ skippable: false, bigWins: true });
    const tgrEnd: State                                 = new TGREnd();
    const autoplayDelay: State                          = new DelayState(500);
    const autoplay: State                               = new Autoplay();
    const tgrRetriggerFreespins: State                  = new TGRRetriggerFreespins();
    const tgrEnterFreespins: State                      = new TGREnterFreespins();
    const freespinIdle: State                           = new FreespinIdle();
    const tgrExitFreespins: State                       = new TGRExitFreespins();
    const tgrRequestFreespin: State                     = new TGRRequestFreespin();
    const wcTGRLoopwins: State                          = new TGRLoopwins();
    const wcLoopWinsFreespins: State                    = new TGRLoopwins();
    const loopWinsHistoryPopup: State                   = new TGRLoopWinsHistoryState();
    const pcHistorySpin: State                          = new PartnerConnectHistorySpin();
    const tgrAddQuickhitSymbolsToReels: State           = new TGRAddQuickhitSymbolsToReels();
    const pcHistoryStart: State                         = new PartnerConnectHistoryStart();
    const pcHistoryComplete: State                      = new PartnerConnectHistoryPopupState();
    const pcHistoryFreespin: State                      = new TGRPartnerConnectHistoryFreespin();

    // super states
    const tgrWinCycle                                   = new TGRWinCycle();

    // decisions
    const isRecovery: Decision                          = new IsRecovery();
    const isWin: Decision                               = new IsTGRWin();
    const pcHistoryCompleteIsWinCheck: Decision         = new IsTGRWin();
    const isTGRWinCheck: Decision                       = new IsTGRWin();
    const isTGRWinCheckEnd: Decision                    = new IsTGRWin();
    const noWinInFreespin: Decision                     = new InFreespins();
    const isTGRInstantWin: Decision                     = new IsTGRInstantWin();
    const noWinInFreespinsCheck: Decision               = new InFreespins();
    const noWinShouldExitFreespins: Decision            = new ShouldTGRExitFreespins();
    const gameOverIsAutoplay: Decision                  = new IsTGRAutoplay();
    const autoplayDoubleCheck: Decision                 = new IsTGRAutoplay();
    const retriggerInFreespins: Decision                = new FreespinsRetriggered();
    const tgrFreespinsTriggered: Decision               = new IsTGRFreespinsTriggered();
    const shouldExitFreespins: Decision                 = new ShouldTGRExitFreespins();
    const wcCompleteIsTGRFreespinsTriggered: Decision   = new IsTGRFreespinsTriggered();
    const wcCompleteIsFreespins: Decision               = new InFreespins();
    const wcCompleteIsAutoplay: Decision                = new IsTGRAutoplay();
    const wcCompleteHasWinlines: Decision               = new IsTGRWin(false);
    const isTGRFirstFreespin: Decision                  = new IsTGRFirstFreespin();
    const pcIsHistoryWins: Decision                     = new PartnerConnectIsHistory();
    const pcIsHistoryIdle: Decision                     = new PartnerConnectIsHistory();
    const pcIsHistoryComplete: Decision                 = new PartnerConnectIsHistoryComplete();
    const pcIsHistoryFreespin: Decision                 = new PartnerConnectIsHistory();

    stateMachine.addSuperStates([
        {
            superState: tgrWinCycle,
            entrySubState: wcCompleteIsTGRFreespinsTriggered,
            links: {
                "exit-1":   retriggerInFreespins,
                "exit-2":   retriggerInFreespins,
                "exit-3":   isTGRWinCheckEnd,
                "exit-4":   gameOverIsAutoplay,
                "exit-5":   tgrRequestSpin,
                "collapse": isTGRWinCheckEnd
            }
        } as SuperStateNode
    ]);

    stateMachine.addStates([
        { state: tgrInit,                               links: { complete: isRecovery }, entryPoint: true },
        { state: tgrIdle,                               links: { complete: tgrRequestSpin, skip: tgrRequestSpin } },
        { state: tgrRequestSpin,                        links: { complete: spin, skip: spin, error: tgrIdle }, cascadeSkip: true, turboSkip: true },
        { state: tgrRecoverySpin,                       links: { complete: spin } },
        { state: pcHistorySpin,                         links: { complete: spin, skip: spin, error: tgrIdle }, cascadeSkip: true },
        { state: spin,                                  links: { complete: isTGRWinCheck, skip: isTGRWinCheck, error: tgrIdle }, turboSkip: true },
        { state: tgrEnd,                                links: { complete: gameOverIsAutoplay } },
        { state: tgrShowInstantWins,                    links: { complete: tgrShowWinLines } },
        { state: tgrShowWinLines,                       links: { complete: pcIsHistoryComplete, skip: pcIsHistoryComplete }, turboSkip: true },
        { state: tgrEnterFreespins,                     links: { complete: freespinIdle } },
        { state: tgrRetriggerFreespins,                 links: { complete: freespinIdle } },
        { state: tgrAddQuickhitSymbolsToReels,          links: { complete: spin } },
        { state: freespinIdle,                          links: { complete: pcIsHistoryFreespin } },
        { state: tgrRequestFreespin,                    links: { complete: isTGRFirstFreespin } },
        { state: tgrExitFreespins,                      links: { complete: tgrWinCycle } },
        { state: autoplayDelay,                         links: { complete: autoplayDoubleCheck } },
        { state: autoplay,                              links: { complete: tgrRequestSpin } },
        { state: wcTGRLoopwins,                         links: { complete: wcTGRLoopwins, skip: "exit-5" } },
        { state: wcLoopWinsFreespins,                   links: { complete: "exit-2", skip: "exit-2" } },
        { state: pcHistoryStart,                        links: { complete: tgrRecoverySpin } },
        { state: pcHistoryFreespin,                     links: { complete: tgrRequestFreespin } },
        { state: loopWinsHistoryPopup,                  links: { complete: loopWinsHistoryPopup } },
        { state: pcHistoryComplete,                     links: { complete: pcHistoryComplete } }
    ]);

    stateMachine.addDecisions([
        { decision: isRecovery,                         links: { true: tgrRecoverySpin, false: pcIsHistoryIdle } },
        { decision: isWin,                              links: { true: isTGRInstantWin, false: noWinInFreespin } },
        { decision: isTGRWinCheckEnd,                   links: { true: gameOverIsAutoplay, false: tgrEnd } },
        { decision: noWinInFreespin,                    links: { true: noWinShouldExitFreespins, false: gameOverIsAutoplay } },
        { decision: isTGRWinCheck,                      links: { true: isTGRInstantWin, false: noWinInFreespinsCheck } },
        { decision: isTGRInstantWin,                    links: { true: tgrShowInstantWins , false: tgrShowWinLines } },
        { decision: noWinInFreespinsCheck,              links: { true: noWinShouldExitFreespins , false: tgrEnd } },
        { decision: noWinShouldExitFreespins,           links: { true: tgrExitFreespins , false: freespinIdle } },
        { decision: gameOverIsAutoplay,                 links: { true: autoplayDelay , false: pcIsHistoryWins } },
        { decision: autoplayDoubleCheck,                links: { true: autoplay , false: tgrIdle } },
        { decision: retriggerInFreespins,               links: { true: tgrRetriggerFreespins , false: tgrFreespinsTriggered } },
        { decision: tgrFreespinsTriggered,              links: { true: tgrEnterFreespins , false: shouldExitFreespins } },
        { decision: shouldExitFreespins,                links: { true: tgrExitFreespins , false: freespinIdle } },
        { decision: isTGRFirstFreespin,                 links: { true: tgrAddQuickhitSymbolsToReels, false: spin } },
        { decision: wcCompleteIsTGRFreespinsTriggered,  links: { true: "exit-1", false: wcCompleteIsFreespins } },
        { decision: wcCompleteIsFreespins,              links: { true: wcLoopWinsFreespins, false: wcCompleteIsAutoplay } },
        { decision: wcCompleteIsAutoplay,               links: { true: "exit-3", false: wcCompleteHasWinlines } },
        { decision: wcCompleteHasWinlines,              links: { true: wcTGRLoopwins , false: "exit-4" } },
        { decision: pcIsHistoryIdle,                    links: { true: pcHistoryStart, false: tgrIdle } },
        { decision: pcIsHistoryWins,                    links: { true: pcHistoryCompleteIsWinCheck, false: tgrIdle } },
        { decision: pcIsHistoryFreespin,                links: { true: pcHistoryFreespin, false: tgrRequestFreespin } },
        { decision: pcIsHistoryComplete,                links: { true: pcHistoryCompleteIsWinCheck, false: tgrWinCycle } },
        { decision: pcHistoryCompleteIsWinCheck,        links: { true: loopWinsHistoryPopup, false: pcHistoryComplete } }
    ]);
}
